/**
 * @author PoornaChandu
 * @description 
 */
import React, { useState, useEffect, useRef } from "react";
import dayjs from "dayjs";
import { Form } from "antd";
import utc from 'dayjs/plugin/utc';
import { connect } from "react-redux";
import localStorage from "../../utils/localStorage";
import HierarchyModal from "./Utils/HierarchyModal";
import StyledTable from "../../commons/styles/table";
import { useNavigate } from 'react-router-dom';
import './CSS/trends.css';
import {
  Select,
  Button,
  DatePicker,
  message,
  Modal,
  Input,
  Divider,
  Dropdown,
  Typography,
  Space,
  Radio
} from "antd";
import {
  getParametersList,
  getUserHeirarchyData,
  getHierarchyTreeData,
  CreateTrend,
  getBookmarkList,
  UpdateTrends,
  getOperationList,
  DeleteTrend,
  getDeviceList,
  getAssetList
} from "./ChartCalls";
import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  EyeOutlined,
  UpSquareOutlined,
} from "@ant-design/icons";
const { RangePicker } = DatePicker;
const { Option } = Select;
const intervalData = [
  {
    key: "1Min",
    value: "1m",
  },
  {
    key: "15Min",
    value: "15m",
  },
  {
    key: "30Min",
    value: "30m",
  },
  {
    key: "60Min",
    value: "1h",
  },
  {
    key: "Day",
    value: "1d",
  },
];
const FilterComponent = (props) => {
  
  const [module, setModule] = useState("");
  const [equipmentList, setEquipmentList] = useState([]);
  const [ParameterList, setParameterList] = useState({});
  const [operationalList, setOperationalList] = useState({});
  const [ParameterListByType, setParameterListByType] = useState([]);
  const [typeChangeModal, setTypeChangeModal] = useState(false);
  const [tunedData, setTunedData] = useState({});
  const [selectedOption, setSelectedOption] = useState('Device');
  const [selectedType, setSelectedType] = useState('');
  const currentTab = "day";
  const [bookmarkName, setBookmarkName] = useState("");
  const [bookMark, setBookMark] = useState("");
  const navigate = useNavigate();
  const [GraphType, setGraphType] = useState(props.GraphType || "line");
  const [viewType, setViewType] = useState('Single');
  const [userProfile, setUserProfile] = useState(props.userProfile);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [type, setType] = useState('live');
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [checkedValue, setCheckedValue] = useState([]);
  const [selectedParameter, setSelectedParameter] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState(undefined);
  const [selectedParameterType, setSelectedParameterType] = useState([]);
  const [selectedInterval, setSelectedInterval] = useState(undefined);
  const [selectedFromDate_ToDate, setSelectedFromDate_ToDate] = useState([]);
  const [selectedFromDate_ToDate1, setSelectedFromDate_ToDate1] = useState([dayjs(), dayjs()]);
  const [selectedDateRangeComparision, setSelectedDateRangeComparision] = useState([]);
  const [isModalSaveBookmark, setIsModalSaveBookmark] = useState(false);
  const [isModalViewBookmark, setIsModalViewBookmark] = useState(false);
  const [fieldVisible, setFieldVisible] = useState(true);
  const [treeVisible, setTreeVisible] = useState(false);
  const [hierarchyArray, setHierarchyArray] = useState([]);
  const [bookmarkList, setBookmarkList] = useState([]);
  const [Id, setId] = useState(null);
  const [source, setSource] = useState("Trends");
  const [devicesList, setDevicesList] = useState([]);
  const [assetsList, setAssetsList] = useState([]);
  const [selectedHierarchy, setSelectedHierarchy] = useState([]);
  const formHeader = useRef();
  const bookMarkRef = useRef();
  const abortController = useRef(new window.AbortController());
  useEffect(() => {
    const fetchData = async () => {
      const Module = props.match?.params?.module;
      const BookmarkList = await getBookmarkList(Module);
      const devicesList = await getDeviceList();
      const assetsList = await getAssetList();
      const HierarchyData = await getUserHeirarchyData();
      const permissionsArray = HierarchyData?.belongsTo?.sites?.[localStorage.get("currentSite")]?.hierarchy;
      setModule(Module);
      setDevicesList(devicesList);
      setAssetsList(assetsList);
      setBookmarkList(BookmarkList);
      setHierarchyArray(permissionsArray);

    };
    fetchData();
    return () => {
      abortController.current.abort();
    };
  }, [props.match]);
  useEffect(() => {
    if (props.translationCache !== translationCache || props.userProfile !== userProfile) {
      setTranslationCache(props.translationCache);
      setUserProfile(props.userProfile);
    }
  }, [props.translationCache, props.userProfile]);
  const onChangeFromDate_ToDate = (selectedFromDate_ToDate) => {
    setSelectedFromDate_ToDate(selectedFromDate_ToDate);
  };
  const onChangeFromDate_ToDate1 = (dates) => {
    setSelectedFromDate_ToDate1(dates);
  };
  const onChangeFromDate1_ToDate1 = (selectedDateRangeComparision) => {
    setSelectedDateRangeComparision(selectedDateRangeComparision);
  };
  const onChange = (SelectedValue) => {
    let form = formHeader.current && formHeader.current.getFieldsValue();

    if (form.Id && form.Id !== null && form.Id !== undefined) {
      if (selectedOption !== SelectedValue && checkedValue.length !== 0) {
        setTypeChangeModal(true);
        setSelectedType(selectedDevice);
      } else {
        setSelectedOption(SelectedValue);
      }
    } else {
      if (
        selectedDevice &&
        Array.isArray(selectedDevice) &&
        selectedDevice.length > 0 &&
        selectedOption !== SelectedValue &&
        checkedValue.length !== 0
      ) {
        setTypeChangeModal(true);
        setSelectedType(SelectedValue);
      } else {
        setSelectedOption(SelectedValue);
        setCheckedValue([]);
      }
      // setState({ selectedOption: SelectedValue, checkedValue: [] });
    }
  };
  const onTypeChangeModalOk = () => {
    setSelectedOption(selectedType);
    setTypeChangeModal(false);
    setSelectedDevice([]);
    setCheckedValue([]);
  };
  const OnResetFields = () => {
    if (formHeader.current) {
      formHeader.current.setFieldsValue({
        type: "live",
        trendData: [],
        EquipmentList: [],
        selectedDevice: [],
        checkedValue: [],
        selectedParameter: [],
        selectedOperator: undefined,
        selectedParameterType: [],
        selectedInterval: undefined,
        selectedFromDate_ToDate: [],
        selectedFromDate_ToDate1: [],
        selectedDateRangeComparision: [],
        ViewType: "Single",
        fieldVisible: true,
        GraphType: "line",
        selectedHierarchy: "",
        selectedOption: 'Device',
        ParameterList: [],
        ParameterListByType: [],
      });
    }
    setType("live");
    setEquipmentList([]);
    setSelectedDevice([]);
    setCheckedValue([]);
    setSelectedParameter([]);
    setSelectedOperator(undefined);
    setSelectedParameterType([]);
    setSelectedInterval(undefined);
    setSelectedFromDate_ToDate([]);
    setSelectedFromDate_ToDate1([]);
    setSelectedDateRangeComparision([]);
    setBookmarkName("");
    setId(undefined);
    setViewType("Single");
    setFieldVisible(true);
    setGraphType("line");
    setSelectedHierarchy(undefined);
    setParameterList([]);
    setParameterListByType([]);
    setSelectedOption('Device');
    props.OnGenerateTrendData({}, {}, "Trends");
    // props.source('Trends');
  };
  const OnGenerateTrendData = () => {
    const filterObject = {
      type: type,
      selectedFromDate_ToDate: selectedFromDate_ToDate,
      selectedFromDate_ToDate1: selectedFromDate_ToDate1,
      selectedDateRangeComparision: selectedDateRangeComparision,
      selectedInterval: selectedInterval,
      ViewType: viewType,
      CurrentTab: currentTab,
      selectedParameter: selectedParameter,
      selectedOperator: selectedOperator,
      selectedParameterType: selectedParameterType,
    };

    formHeader.current &&
      formHeader.current
        .validateFields()
        .then(async () => {
          const tunedData = trendAdapter();

          if (source && source !== undefined) {
            props.OnGenerateTrendData(tunedData, filterObject, source, selectedOption, 'day');
            // props.source(source);
          } else {
            props.OnGenerateTrendData(tunedData, filterObject, "Trends", selectedOption, 'day');
            // props.source('Trends');
          }

          setTunedData(tunedData);
        })
        .catch((error) => {
          console.log(error);
        });
    // if (formHeader.current) {
    //   try {
    //      formHeader.current.validateFields();
    //     const tunedData = trendAdapter(); 
    //     props.OnGenerateTrendData(tunedData, filterObject, "Trends");
    //     setTunedData(tunedData);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }
  };
  dayjs.extend(utc);
  const trendAdapter = () => {
    try {
      let data = selectedParameter && Array.isArray(selectedParameter) && selectedParameter.map((deviceParameter) => {
        let spliteData = deviceParameter.split("@@");
        if (selectedOption === 'Device') {
          return {
            DeviceCode: spliteData[0],
            ParameterCode: spliteData[1]
          };
        } else {
          return {
            AssetCode: spliteData[0],
            ParameterCode: spliteData[1]
          };
        }
      });
      let Payload = {
        Type: type,
        ViewType: viewType,
        ParameterList: data,
        CodeType: selectedOption
      };
      if (selectedParameterType === 'Operational') {
        Payload.GraphType = 'line';
        if (type !== 'live') {
          Payload.Operator = selectedOperator;
        }
      }
      if (selectedParameterType === 'Status' || selectedParameterType === 'Fault') {
        Payload.GraphType = 'Table';
      }
      if (type !== 'live' && (selectedOperator === 'FIRST' || selectedOperator === 'LAST' || selectedOperator === 'RAW')) {
        Payload.Operator = selectedOperator;
      }
      if (type === "historic") {
        Payload.Interval = selectedInterval;
        Payload.FromDate = dayjs(selectedFromDate_ToDate1[0]).utc().format('YYYY-MM-DD HH:mm:ss');
        Payload.ToDate = dayjs(selectedFromDate_ToDate1[1])
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
      } else if (type === "timeRange") {
        Payload.FromDate1 = dayjs(selectedFromDate_ToDate[0])
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        Payload.ToDate1 = dayjs(selectedFromDate_ToDate[1])
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        Payload.FromDate2 = dayjs(selectedDateRangeComparision[0])
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        Payload.ToDate2 = dayjs(selectedDateRangeComparision[1])
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        Payload.Interval = selectedInterval;
      } else if (type === "timeWithSelectionType") {
        Payload.FromDate = dayjs(selectedFromDate_ToDate1[0])
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        Payload.ToDate = dayjs(selectedFromDate_ToDate1[1])
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        Payload.Interval = selectedInterval;
        Payload.SelectionType = currentTab;
      }
      return Payload;
    } catch (error) {
      console.error('Error generating payload:', error);
      return {};
    }
  };
  const hierarchyDropdownChange = (value) => {
    setCheckedValue(value);
  };
  const onModalsOk = (e) => {
    e.preventDefault();
    OnDeviceChange(checkedValue);
    setTreeVisible(false);
    setSelectedOption(selectedOption);
  };

  const onModalCancel = () => {
    if (selectedDevice && Array.isArray(selectedDevice) && selectedDevice.length > 0) {
      setCheckedValue(selectedDevice);
    } else {
      setCheckedValue([]);
    }
    let formId = formHeader.current && formHeader.current.getFieldsValue();

    if (!formId.Id && !selectedDevice) {
      setSelectedOption('Device');
    }
    setTreeVisible(false);

  };
  const OnDeviceChange = async (value) => {
    let val = [];
    val.push(value);
    let ParameterList = {};
    let payload = {};
    const siteId = localStorage.get('currentSite');
    if (selectedOption === 'Asset') {
      if (value.length === 6) {
        value.shift();
        payload = {
          AssetCode: val,
          SiteId: siteId,
          CodeType: 'Asset'
        };
        ParameterList = await getParametersList(payload);
      } else {
        payload = {
          AssetCode: val,
          SiteId: siteId,
          CodeType: 'Asset'
        };
        ParameterList = await getParametersList(payload);
      }
    } else {
      if (value.length === 6) {
        payload = {
          DeviceCode: val,
          SiteId: siteId,
          CodeType: 'Device'
        };
        value.shift();
        ParameterList = await getParametersList(payload);
      } else {
        payload = {
          DeviceCode: val,
          SiteId: siteId,
          CodeType: 'Device'
        };
        ParameterList = await getParametersList(payload);
      }
    }
    // setUpdate(false);
    setSelectedDevice(value);
    setParameterList(ParameterList);
    setParameterListByType([]);
    setSelectedParameterType(undefined);
    setSelectedParameter([]);
    setSelectedOperator(undefined);
    if (formHeader.current) {
      formHeader.current.setFieldsValue({
        selectedDevice: value,
        ParameterList,
        update: false,
        ParameterListByType: [],
        selectedParameterType: undefined,
        selectedParameter: [],
        selectedOperator: undefined,
      });
    }
  };
  const OnParameterChange = (value) => {
    if (type === "timeRange" && value.length === 2) {
      value.shift();
      setSelectedParameter(value);
    } else if (type === "timeWithSelectionType" && value.length === 2) {
      value.shift();
      setSelectedParameter(value);
    } else if (value.length > 5) {
      value.shift();
      setSelectedParameter(value);
    } else {
      setSelectedParameter(value);
    }
  };
  const OnOperatorChange = (value) => {
    setSelectedOperator(value);
  };
  const OnParameterTypeChange = async (selectedParameterType) => {
    let OperationalList = {};
    if (
      (selectedParameterType === 'OnChange' || selectedParameterType === 'Status' || selectedParameterType === 'Fault') &&
      type !== 'live'
    ) {
      setGraphType('Table');
      let GraphType = 'Table';
      OperationalList = await getOperationList(
        selectedParameterType,
        GraphType,
        selectedOption
      );
      setFieldVisible(true);
      setOperationalList(OperationalList);
    }
    if (
      selectedParameterType !== 'Operational' ||
      ((selectedParameterType === 'OnChange' || selectedParameterType === 'Status' || selectedParameterType === 'Fault') &&
        type === 'live')
    ) {
      setFieldVisible(false);
      setSelectedOperator(undefined);

    } else if (selectedParameterType === 'Operational' && type !== 'live') {
      OperationalList = await getOperationList(
        selectedParameterType,
        GraphType,
        selectedOption
      );
      setFieldVisible(true);
      setOperationalList(OperationalList);
      setSelectedOperator(selectedOperator);
    }

    setParameterListByType(ParameterList[selectedParameterType]);
    setSelectedParameterType(selectedParameterType);
    setSelectedParameter([]);
    setSelectedOperator(undefined);
    formHeader.current &&
      formHeader.current.setFieldsValue({
        selectedParameterType,
        selectedParameter: [],
        selectedOperator: undefined
      });
  };

  const disabledDate = (current) => {
    return current && current > dayjs();
  };
  const OnTypeChange = (value) => {
    const viewType = value && (value === "timeRange" || value === "timeWithSelectionType") ? "Multiple" : "Single";
    setType(value);
    // setTrendData([]);
    // setLoading(false);
    // setCurrentSelectionTab("day");
    setGraphType("line");
    setViewType(viewType);
    setTunedData({});
    setSelectedDevice([]);
    setSelectedParameter([]);
    setSelectedParameterType([]);
    setSelectedInterval(undefined);
    setSelectedFromDate_ToDate([]);
    setSelectedFromDate_ToDate1([]);
    setSelectedDateRangeComparision([]);
    setSelectedHierarchy(undefined);
    if (formHeader.current) {
      formHeader.current.setFieldsValue({
        type: value,
        ViewType: viewType,
        selectedDevice: [],
        selectedParameter: [],
        selectedParameterType: [],
        selectedInterval: undefined,
        selectedFromDate_ToDate: [],
        selectedFromDate_ToDate1: [],
        selectedDateRangeComparision: [],
        selectedHierarchy: undefined,
      });
    }
  };
  const onHierarchySelect = async (value) => {
    const EquipmentList = await getHierarchyTreeData(value);
    setSelectedHierarchy(value);
    setSelectedDevice([]);
    setSelectedParameter([]);
    setSelectedParameterType([]);
    setSelectedOperator([]);
    setCheckedValue([]);
    setEquipmentList(EquipmentList);
  };
  const translation = (keyword) => {
    const { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const onBookmarkSave = async () => {
    const siteId = localStorage.get("currentSite");

    if (bookMark && bookMark.length > 0) {
      const payload = {
        Devices: selectedDevice,
        Interval: selectedInterval,
        Module: module,
        Name: bookMark,
        Parameters: selectedParameter,
        ParameterType: selectedParameterType,
        Payload: tunedData ? tunedData : [],
        SiteId: siteId,
        Type: type,
        ViewType: viewType,
        Operator: selectedOperator,
        HierarchyCode: selectedHierarchy,
      };
      const saveBookmarkResponse = await CreateTrend(payload);
      if (saveBookmarkResponse && saveBookmarkResponse.message) {
        message.success(saveBookmarkResponse.message);
        setBookmarkName(bookMark);
        const BookmarkList = await getBookmarkList(module);
        setBookmarkList(BookmarkList);
        // bookMarkRef.current && bookMarkRef.current.setFieldsValue({
        //   BookmarkName:undefined
        // });
        // setBookMark(undefined);
        setIsModalSaveBookmark(false);
      }
    } else {
      message.warning("Please input Bookmark name");
    }
  };
  const updateBookmark = async () => {
    const siteId = localStorage.get("currentSite");
    const payload = {
      Devices: selectedDevice,
      Interval: selectedInterval,
      Module: module,
      Name: bookmarkName,
      Parameters: selectedParameter,
      ParameterType: selectedParameterType,
      Payload: tunedData ? tunedData : [],
      SiteId: siteId,
      Type: type,
      ViewType: viewType,
      Id: Id,
      Operator: selectedOperator,
      HierarchyCode: selectedHierarchy,
    };
    const updateBookmarkResponse = await UpdateTrends(payload);
    if (updateBookmarkResponse && updateBookmarkResponse.message) {
      message.success(updateBookmarkResponse.message);
      const BookmarkList = await getBookmarkList(module);
      setBookmarkList(BookmarkList);
    }
  };
  const onBookmarkModalOpen = () => {
    if (bookMarkRef.current) {
      bookMarkRef.current.setFieldsValue({
        BookmarkName: undefined
      });
    }
    setIsModalSaveBookmark(true);
    setBookMark(undefined);
  };
  const onBookmarkListOpen = () => {
    setIsModalViewBookmark(true);
  };
  const deleteBookmark = async (record) => {
    const deleteResponse = await DeleteTrend(record.Id);
    if (deleteResponse && deleteResponse.message) {
      message.success(deleteResponse.message);
      const BookmarkList = await getBookmarkList(module);
      setBookmarkList(BookmarkList);
    }
  };
  
  const editBookmark = async (editObject, type) => {
    if (type && type !== undefined) {
      setSource(type);
      // props.source(type);
    } else {
      setSource('Trends');
      // props.source('Trends');

    }

    const EquipmentList = await getHierarchyTreeData(editObject.HierarchyCode);
    let val = [];
    val.push(editObject.Devices);
    let ParameterList = {};
    let OperationalList = {};
    let ParameterListByType = [];
    let { GraphType } = props;
    const siteId = localStorage.get('currentSite');
    if (editObject.Devices) {
      let payload = {};
      if (editObject.Payload.CodeType === 'Device') {
        payload = {
          DeviceCode: val,
          SiteId: siteId,
          CodeType: editObject.Payload.CodeType
        };
      } else {
        payload = {
          AssetCode: val,
          SiteId: siteId,
          CodeType: editObject.Payload.CodeType
        };
      }

      ParameterList = await getParametersList(payload);
      ParameterListByType = ParameterList[editObject.ParameterType];
      if (
        (editObject.ParameterType === 'Status' || editObject.ParameterType === 'Fault' || editObject.ParameterType === 'OnChange') &&
        editObject.Type !== 'live'
      ) {
        OperationalList = await getOperationList(
          editObject.ParameterType,
          'Table',
          selectedOption
        );
      } else if (editObject.ParameterType === 'Operational' && editObject.Type !== 'live') {
        OperationalList = await getOperationList(
          editObject.ParameterType,
          GraphType,
          selectedOption
        );
      }
    }
    setSelectedHierarchy(editObject.HierarchyCode);
    setEquipmentList(EquipmentList);
    setType(editObject.Type);
    setSelectedDevice(editObject.Devices);
    setCheckedValue(editObject.Devices);
    setSelectedParameter(editObject.Parameters);
    setSelectedParameterType(editObject.ParameterType);
    setSelectedInterval(editObject.Interval);
    setSelectedDateRangeComparision([
      dayjs.utc(editObject.Payload.FromDate2, "YYYY-MM-DD HH:mm:ss").local(),
      dayjs.utc(editObject.Payload.ToDate2, "YYYY-MM-DD HH:mm:ss").local(),
    ]);
    setIsModalViewBookmark(false);
    setViewType(editObject.ViewType);
    setSelectedOperator(editObject.Operator);
    setSelectedOption(editObject.Payload.CodeType);
    setId(editObject.Id);
    setBookmarkName(editObject.Name);
    setSelectedFromDate_ToDate([
      dayjs.utc(editObject.Payload.FromDate1, "YYYY-MM-DD HH:mm:ss").local(),
      dayjs.utc(editObject.Payload.ToDate1, "YYYY-MM-DD HH:mm:ss").local(),
    ]);
    setSelectedFromDate_ToDate1([
      dayjs.utc(editObject.Payload.FromDate, "YYYY-MM-DD HH:mm:ss").local(),
      dayjs.utc(editObject.Payload.ToDate, "YYYY-MM-DD HH:mm:ss").local(),
    ]);
    setParameterList(ParameterList);
    setParameterListByType(ParameterListByType);
    setTunedData(editObject.Payload);
    setOperationalList(OperationalList);
    if (formHeader.current) {
      formHeader.current.setFieldsValue({
        selectedHierarchy: editObject.HierarchyCode,
        type: editObject.Type,
        selectedDevice: editObject.Devices,
        selectedOption: editObject.Payload.CodeType,
        checkedValue: editObject.Devices,
        selectedParameter: editObject.Parameters,
        selectedParameterType: editObject.ParameterType,
        selectedInterval: editObject.Interval,
        selectedDateRangeComparision: [
          dayjs.utc(editObject.Payload.FromDate2, "YYYY-MM-DD HH:mm:ss").local(),
          dayjs.utc(editObject.Payload.ToDate2, "YYYY-MM-DD HH:mm:ss").local(),
        ],
        ViewType: editObject.ViewType,
        selectedOperator: editObject.Operator,
        selectedFromDate_ToDate: [
          dayjs.utc(editObject.Payload.FromDate1, "YYYY-MM-DD HH:mm:ss").local(),
          dayjs.utc(editObject.Payload.ToDate1, "YYYY-MM-DD HH:mm:ss").local(),
        ],
        selectedFromDate_ToDate1: [
          dayjs.utc(editObject.Payload.FromDate, "YYYY-MM-DD HH:mm:ss").local(),
          dayjs.utc(editObject.Payload.ToDate, "YYYY-MM-DD HH:mm:ss").local(),
        ],
      });
    }
  };
  
  const columns = [
    {
      title: translation("Bookmark Name"),
      dataIndex: "Name",
      key: "Name",
      width: 150,
    },
    {
      title: translation("Type"),
      dataIndex: "Type",
      key: "Type",
      width: 150,
    },
    {
      title: translation("Devices"),
      dataIndex: "Devices",
      key: "Devices",
      width: 150,
      render: (devices, record) => {
        let deviceNames = null;
        if (!devices || devices.length === 0) return '-';
        if (
          record &&
          record.Payload &&
          record.Payload.CodeType &&
          record.Payload.CodeType === 'Device'
        ) {
          // Map device codes to device names
          deviceNames =
            devices &&
            devices.map((deviceCode) => {
              const device = devicesList && devicesList.find((d) => d.AliasCode === deviceCode);
              return device ? device.Name : deviceCode;
            });
        } else {
          deviceNames =
            devices &&
            devices.map((deviceCode) => {
              const device = assetsList && assetsList.find((d) => d.AliasCode === deviceCode);
              return device ? device.Name : deviceCode;
            });
        }
        return deviceNames.join(', ');
      }

    },
    {
      title: translation("Parameters"),
      dataIndex: "Parameters",
      key: "Parameters",
      width: 150,
    },
    {
      title: translation("Parameter Type"),
      dataIndex: "ParameterType",
      key: "ParameterType",
      width: 150,
    },
    {
      title: translation("View Type"),
      dataIndex: "ViewType",
      key: "ViewType",
      width: 150,
    },
    {
      title: translation("Actions"),
      dataIndex: "",
      key: "",
      width: 150,
      render: (text, record) => (
        <span>
          <a target="_blank" rel="noopener noreferrer">
            <EyeOutlined
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/rubus/ViewTrends/${record.Id}`);
                editBookmark(record, 'ViewTrends');
                // props.source('ViewTrends')
              }}
            />
          </a>
          <Divider type="vertical" />
          <EditOutlined
            onClick={(e) => {
              e.stopPropagation();
              editBookmark(record, 'Trends');
            }}
          />
          <Divider type="vertical" />
          <DeleteOutlined
            onClick={(e) => {
              e.stopPropagation();
              deleteBookmark(record);
            }}
          />
        </span>
      ),
    },
  ];
  const items = [
    {
      key: Id
        ? translation("update")
        : translation("save"),
      label: Id
        ? translation("Update bookmark")
        : translation("Save bookmark"),
    },
    {
      key: "list",
      label: translation("View bookmarks"),
    },
  ];
  let permissionsArray = [];
  userProfile &&
    userProfile["belongsTo"] &&
    userProfile["belongsTo"]["sites"] &&
    userProfile["belongsTo"]["sites"][localStorage.get("currentSite")] &&
    userProfile["belongsTo"]["sites"][localStorage.get("currentSite")][
    "role"
    ] &&
    userProfile["belongsTo"]["sites"][localStorage.get("currentSite")][
      "role"
    ]["Permission"]
      .filter((item) => item.resource === "trends")
      .map((name) => permissionsArray.push(name.action));      

  return (
    <>
      {bookmarkName !== '' ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '13px',
            color: '#ffffff'
          }}>
          {translation('Bookmark')}: {bookmarkName}
        </div>
      ) : null}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          marginBottom: '10px'
        }}>
        <Dropdown
          menu={{
            items,
            selectable: true,
            onClick: (e) => {
              if (e.key === 'list') {
                onBookmarkListOpen();
              } else if (e.key === 'save') {
                formHeader.current &&
                  formHeader.current
                    .validateFields()
                    .then(async () => {
                      onBookmarkModalOpen();
                    })
                    .catch(() => {
                      message.warning(
                        translation('Please input mandatory fields to save bookmark')
                      );
                    });
              } else if (e.key === 'update') {
                formHeader.current &&
                  formHeader.current
                    .validateFields()
                    .then(async () => {
                      updateBookmark();
                    })
                    .catch(() => {
                      message.warning(
                        translation('Please input mandatory fields to update bookmark')
                      );
                    });
              }
            }
          }}>
          <Typography.Link>
            <Space>
              {translation('Bookmark Options')}
              <DownOutlined />
            </Space>
          </Typography.Link>
        </Dropdown>
      </div>

      <Form ref={formHeader} layout="vertical">
        <Form.Item
          name={'type'}
          label={translation('Select Trend Type')}
          rules={[
            {
              required: true,
              message: translation('Please Select TrendType!')
            }
          ]}>
          <Select placeholder={translation('Select Trend Type')} onChange={OnTypeChange}>
            <Option value="live">{translation('Live Trend')}</Option>
            <Option value="historic">{translation('Historical Trend')}</Option>
            <Option value="timeRange">
              {translation('Trend between two different TimeRanges')}
            </Option>
            <Option value="timeWithSelectionType">
              {translation('Trend based Day Week Month Year Comparision')}
            </Option>
          </Select>
        </Form.Item>
        <Form.Item
          name={'selectedHierarchy'}
          label={translation('Select Hierarchy')}
          rules={[
            {
              required: true,
              message: translation('Please Select Hierarchy!')
            }
          ]}>
          <Select onChange={onHierarchySelect} placeholder={translation('Select Hierarchy')}>
            {hierarchyArray &&
              Array.isArray(Object.keys(hierarchyArray)) &&
              Object.keys(hierarchyArray).map((device, index) => (
                <Option key={index} value={hierarchyArray[device].HierarchyCode}>
                  {hierarchyArray[device].HierarchyName}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item
          name={'selectedDevice'}
          label={translation('Select Equipment')}
          rules={[
            {
              required: true,
              message: translation('Please Select Equipment!')
            }
          ]}>
          <span style={{ display: 'flex', justifyContent: 'flex-start' }}>
            {selectedOption === 'Device' ? (
              <>
                <Select
                  style={{
                    width: '90%'
                  }}
                  value={selectedDevice}
                  mode="multiple"
                  placeholder={translation('Select Equipment')}
                  disabled={true}>
                  {devicesList &&
                    Array.isArray(devicesList) &&
                    devicesList.map((device, index) => {
                      return (
                        <Option key={index} value={device.AliasCode}>
                          {translation(device.DisplayCode)}
                        </Option>
                      );
                    })}
                </Select>
              </>
            ) : (
              <>
                <Select
                  style={{
                    width: '90%'
                  }}
                  value={selectedDevice}
                  mode="multiple"
                  placeholder={translation('Select Equipment')}
                  disabled={true}>
                  {assetsList &&
                    Array.isArray(assetsList) &&
                    assetsList.map((device, index) => {
                      return (
                        <Option key={index} value={device.AliasCode}>
                          {translation(device.DisplayCode)}
                        </Option>
                      );
                    })}
                </Select>
              </>
            )}

            <Button
              type="primary"
              onClick={() => {
                setTreeVisible(true);
              }}>
              <UpSquareOutlined />
            </Button>
          </span>
        </Form.Item>
        <Form.Item
          name={'selectedParameterType'}
          label={translation('Select Parameter Type')}
          rules={[
            {
              required: true,
              message: translation('Please Select Parameter Type!')
            }
          ]}>
          <Select
            value={selectedParameterType}
            placeholder={translation('Select Parameter Type')}
            onChange={OnParameterTypeChange}>
            {ParameterList &&
              Array.isArray(Object.keys(ParameterList)) &&
              Object.keys(ParameterList).map((parameterType) => (
                <Option key={parameterType}>{parameterType}</Option>
              ))}
          </Select>
        </Form.Item>
        {selectedOption === 'Device' ? (
          <>
            <Form.Item
              name={'selectedParameter'}
              label={translation('Select Parameter')}
              rules={[{ required: true, message: translation('Please Select Parameter!') }]}>
              <Select
                showSearch
                mode="multiple"
                value={selectedParameter}
                onChange={OnParameterChange}
                placeholder={translation('Select Parameter')}>
                {ParameterListByType &&
                  Array.isArray(ParameterListByType) &&
                  ParameterListByType.filter(
                    (param) =>
                      param.ParameterDescription && param.ParameterDescription.trim() !== ''
                  ).map((param, index) => {
                    return (
                      <Option key={index} value={`${param.Device}@@${param.ParameterCode}`}>
                        {`${translation(param.DeviceName)}=>${translation(param.ParameterDescription)}`}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          </>
        ) : (
          <>
            <Form.Item
              name={'selectedParameter'}
              label={translation('Select Parameter')}
              rules={[{ required: true, message: translation('Please Select Parameter!') }]}>
              <Select
                showSearch
                mode="multiple"
                value={selectedParameter}
                onChange={OnParameterChange}
                placeholder={translation('Select Parameter')}>
                {ParameterListByType &&
                  Array.isArray(ParameterListByType) &&
                  ParameterListByType.filter(
                    (param) =>
                      param.ParameterDescription && param.ParameterDescription.trim() !== ''
                  ).map((param, index) => {
                    return (
                      <Option key={index} value={`${param.Asset}@@${param.ParameterCode}`}>
                        {`${param.AssetName}=>${param.ParameterDescription}`}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          </>
        )}

        {(type !== 'live' && fieldVisible === true) ||
        ((selectedParameterType === 'Status' || selectedParameterType === 'Fault') &&
          GraphType === 'Table' &&
          type !== 'live') ? (
          <Form.Item
            name={'selectedOperator'}
            label={translation('Select Operator')}
            rules={[
              {
                required: true,
                message: translation('Please Select Operator !')
              }
            ]}>
            <Select
              value={selectedOperator}
              onChange={OnOperatorChange}
              placeholder={translation('Select Operator')}>
              {operationalList &&
                Array.isArray(operationalList) &&
                operationalList.map((operator, index) => (
                  <Option key={index} value={operator.Key}>
                    {operator.Value}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        ) : null}

        {type === 'historic' ? (
          <>
            <Form.Item
              name={'selectedFromDate_ToDate1'}
              label={translation('Select Range')}
              initialValue={[dayjs(), dayjs()]} // Set initial value to current date and time
              rules={[
                {
                  required: true,
                  message: translation('Please Select DateRanges!')
                },
                {
                  validator: (_, value) => {
                    if (!value || value.length < 2) {
                      return Promise.reject(
                        new Error(translation('Please select both start and end date!'))
                      );
                    }
                    // Allow same date and time
                    return Promise.resolve();
                  }
                }
              ]}>
              <RangePicker
                showTime={{ format: 'HH:mm:ss' }} // Show time in HH:mm:ss format
                format="YYYY-MM-DD HH:mm:ss" // Overall format for the date and time
                placeholder={[translation('Start DateTime'), translation('End DateTime')]}
                value={selectedFromDate_ToDate1}
                onChange={onChangeFromDate_ToDate1}
                disabledDate={disabledDate}
              />
            </Form.Item>
            <Form.Item
              name={'selectedInterval'}
              label={translation('Select Interval')}
              rules={[
                {
                  required: true,
                  message: translation('Please Select Interval!')
                }
              ]}>
              <Select
                placeholder={translation('Select Interval')}
                value={selectedInterval}
                onChange={(value) => setSelectedInterval(value)}>
                {intervalData.map((item, index) => (
                  <Option key={index} value={item.value}>
                    {translation(item.key)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </>
        ) : null}

        {type === 'timeRange' ? (
          <>
            <Form.Item
              name={'selectedFromDate_ToDate'}
              label={translation('Select Range')}
              rules={[
                {
                  required: true,
                  message: translation('Please Select DateRanges!')
                }
              ]}>
              <RangePicker
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder={[translation('Start DateTime'), translation('End DateTime')]}
                value={selectedFromDate_ToDate}
                onChange={onChangeFromDate_ToDate}
                // onOk={onOk}
                disabledDate={disabledDate}
              />
            </Form.Item>
            <Form.Item
              name={'selectedDateRangeComparision'}
              label={translation('Select Range Comparison')}
              rules={[
                {
                  required: true,
                  message: translation('Please Select DateRanges!')
                }
              ]}>
              <RangePicker
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder={[translation('Start DateTime'), translation('End DateTime')]}
                value={selectedDateRangeComparision}
                onChange={onChangeFromDate1_ToDate1}
                // onOk={onOk}
                disabledDate={disabledDate}
              />
            </Form.Item>
            <Form.Item
              name={'selectedInterval'}
              label={translation('Select Interval')}
              rules={[
                {
                  required: true,
                  message: translation('Please Select Interval!')
                }
              ]}>
              <Select
                placeholder={translation('Select Interval')}
                value={selectedInterval}
                onChange={(value) => setSelectedInterval(value)}>
                {intervalData.map((item, index) => (
                  <Option key={index} value={item.value}>
                    {item.key}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </>
        ) : null}
        {type === 'timeWithSelectionType' ? (
          <>
            <Form.Item
              name={'selectedFromDate_ToDate1'}
              label={translation('Select Range')}
              rules={[
                {
                  required: true,
                  message: translation('Please Select DateRanges!')
                }
              ]}>
              <RangePicker
                // className="Picker"
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder={[translation('Start DateTime'), translation('End DateTime')]}
                value={selectedFromDate_ToDate1}
                onChange={onChangeFromDate_ToDate1}
                // onOk={onOk}
                disabledDate={disabledDate}
              />
            </Form.Item>
            <Form.Item
              name={'selectedInterval'}
              label={translation('Select Interval')}
              rules={[
                {
                  required: true,
                  message: translation('Please Select Interval!')
                }
              ]}>
              <Select
                placeholder={translation('Select Interval')}
                value={selectedInterval}
                onChange={(value) => setSelectedInterval(value)}>
                {intervalData.map((item, index) => (
                  <Option key={index} value={item.value}>
                    {item.key}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </>
        ) : null}
        {type === 'timeWithSelectionType' || type === 'timeRange' ? (
          <>
            <Form.Item
              name={'ViewType'}
              label={translation('View Type')}
              rules={[
                {
                  required: true,
                  message: translation('Please Select ViewType!')
                }
              ]}>
              <Select
                placeholder={translation('View Type')}
                value={viewType}
                onChange={(value) => {
                  setViewType(value);
                }}>
                {/* <Option key="Single" value="Single">
                    {translation('Single')}
                  </Option> */}
                <Option key="Multiple" value="Multiple">
                  {translation('Multiple')}
                </Option>
              </Select>
            </Form.Item>
          </>
        ) : (
          <>
            <Form.Item
              name={'ViewType'}
              label={translation('View Type')}
              rules={[
                {
                  required: true,
                  message: translation('Please Select ViewType!')
                }
              ]}>
              <Select
                placeholder={translation('View Type')}
                value={viewType}
                onChange={(value) => {
                  setViewType(value);
                }}>
                <Option key="Single" value="Single">
                  {translation('Single')}
                </Option>
                <Option key="Multiple" value="Multiple">
                  {translation('Multiple')}
                </Option>
              </Select>
            </Form.Item>
          </>
        )}
        <div>
          <Button
            htmlType="submit"
            type="primary"
            disabled={!permissionsArray.includes('read') ? true : false}
            onClick={OnGenerateTrendData}>
            {translation('Generate Trend')}
          </Button>
          <Button
            type="dashed"
            style={{ marginLeft: '5px' }}
            onClick={() => {
              OnResetFields();
            }}>
            {translation('Reset')}
          </Button>
        </div>
      </Form>

      {/* Save Bookmark Modal */}
      <Modal
        title={translation('Save Bookmark')}
        open={isModalSaveBookmark}
        onOk={onBookmarkSave}
        onCancel={() => setIsModalSaveBookmark(false)}
        footer={[
          <Button key="back" onClick={() => setIsModalSaveBookmark(false)}>
            {translation('Cancel')}
          </Button>,
          <Button key="submit" type="primary" onClick={onBookmarkSave}>
            {translation('Save Bookmark')}
          </Button>
        ]}>
        <Form layout="vertical" ref={bookMarkRef}>
          <Form.Item
            name={'BookmarkName'}
            label={translation('Bookmark Name')}
            rules={[
              {
                required: true,
                message: translation('Input Bookmark!')
              }
            ]}>
            <Input onChange={(e) => setBookMark(e.target.value)} />
          </Form.Item>
        </Form>
      </Modal>
      {/* View Bookmarks Modal */}
      <Modal
        width={'900'}
        title="View Bookmarks"
        open={isModalViewBookmark}
        onOk={() => setIsModalViewBookmark(false)}
        onCancel={() => setIsModalViewBookmark(false)}
        footer={[
          <Button key="back" type="primary" onClick={() => setIsModalViewBookmark(false)}>
            {translation('Cancel')}
          </Button>
        ]}>
        <StyledTable
          size="small"
          dataSource={bookmarkList}
          rowKey={Math.random}
          columns={columns}
          scroll={{ x: 120, y: 550 }}
          bordered
        />
      </Modal>
      <Modal
        // title={translation('Save Bookmark')}
        open={typeChangeModal}
        onOk={onBookmarkSave}
        onCancel={() => setTypeChangeModal(false)}
        footer={[
          <Button key="back" onClick={() => setTypeChangeModal(false)}>
            {translation('No')}
          </Button>,
          <Button key="submit" type="primary" onClick={onTypeChangeModalOk}>
            {translation('Yes')}
          </Button>
        ]}>
        Are you want to change the option. If you try to change the option, you will lose data
      </Modal>
      <Modal
        open={treeVisible}
        width={800}
        height={800}
        closable
        title={'Equipment'}
        okText={'Add'}
        onOk={onModalsOk}
        onCancel={onModalCancel}>
        <div style={{ marginLeft: '70%', color: 'white', display: 'flex' }}>
          <Radio.Group value={selectedOption}>
            <Radio.Button value="Device" onChange={() => onChange('Device')}>
              Device
            </Radio.Button>
            <Radio.Button
              value="Asset"
              onChange={() => onChange('Asset')}
              style={{ marginLeft: '10px' }}>
              Asset
            </Radio.Button>
          </Radio.Group>
        </div>

        <HierarchyModal
          checkedArray={checkedValue || []}
          treeData={Object.values(equipmentList)}
          Key="Trends"
          selectedOption={selectedOption}
          translationCache={translationCache}
          handleDropdownChange={hierarchyDropdownChange}
        />
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache,
});
export default connect(mapStateToProps)(FilterComponent);
